import React from 'react'


/**
 * Determines the default selection values for a SocialAccountsSelector.
 * Returns object of same shape as SocialAccountsSelector uses for its onSelected callback TODO: field names of that object are confusing
 *
 * - Uses social pages instead of social credentials if the provider is facebook
 *
 * @param {PostMessage} post - the post object that an social account is being selected for
 * @param {Array.<ChatterListing>} listings - from the PublishingCredentialStore
 * @param {Array.<PublishingCredential>} credentials - from the PublishingCredentialStore
 * @param exclude - set of ids to exclude,
 *                  e.g. if a post has already been liked by some social accounts, exclude them
 *                  set is in the form of a javascript object of string to true,
 *                   { "12345": true, "34567": true }
 *
 * @return {{value: string, userAccountId?:string, remoteId?:string} | null}
 */

export function determineDefaultSelectionForReply({
  post,
  exclude = {}
}) {

  /** e.g. should we be selected to publishing with a "listing/remote page" or with a "credential/remote user" */
  let socialAccount = post.postSourceIds['Credential'][0];

  const shouldDefaultPageId = socialAccount
    && post.remotePageId
    && !exclude[post.remotePageId];


  if (shouldDefaultPageId) {
    return (
      {
        id: `Place:${post.remotePageId}`,
        value: `Place:${post.remotePageId}`,
        pageType: "Place", // TODO - not quite correct, depends on the provider. This shouldn't really matter though
        remoteId: post.remotePageId
      }
    );
  } else {
    return null;
  }

}
